import React from 'react'

import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'

import {
  Button,
  Modal,
  ModalFoot,
  ModalBody,
  InputText,
  ModalHead,
  FormElement
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { modalSaveNewAndRenameState } from '../recoil/state/modals'
import { renameSaveRowCallback } from '../recoil/callbacks/callbacks'
import { beePluginState } from '../recoil/state/editor'

export const ModalSaveAndRename = () => {
  const intl = useIntl()
  const { show, mode, name } = useRecoilValue(modalSaveNewAndRenameState)
  const setState = useSetRecoilState(modalSaveNewAndRenameState)
  const renameSaveRow = useRecoilCallback(renameSaveRowCallback, [])
  const reset = useResetRecoilState(modalSaveNewAndRenameState)
  const { instance: beePluginInstance } = useRecoilValue(beePluginState)

  const handleNameChange = ({ target: { value } }) => {
    setState(prev => ({
      ...prev,
      name: value
    }))
  }

  const handleConfirm = () => {
    if (mode === 'rename') {
      renameSaveRow(name)
    }
    if (mode === 'new') {
      beePluginInstance.saveAsTemplate()
    }
  }

  return (
    <Modal show={show} onClose={reset}>
      <ModalHead
        title={
          mode === 'rename'
            ? intl.formatMessage({ id: 'Load.SaveRow.RenameModalTitle' })
            : intl.formatMessage({ id: 'Load.SaveRow.SaveModalTitle' })
        }
      />
      <ModalBody>
        <FormElement
          label={intl.formatMessage({ id: 'Load.SaveRow.ModalEditLabel' })}
          hint={
            mode === 'rename'
              ? intl.formatMessage({ id: 'Load.SaveRow.ModalEditHinit' })
              : intl.formatMessage({ id: 'Load.SaveRow.SaveModalHinit' })
          }
        >
          <InputText
            placeHolder={
              mode === 'edit-row'
                ? intl.formatMessage({
                    id: 'Load.SaveRow.ModalEditPlaceHolder'
                  })
                : intl.formatMessage({
                    id: 'Load.SaveRow.SaveModalPlaceHolder'
                  })
            }
            value={name}
            onChange={handleNameChange}
            maxlength='100'
          />
        </FormElement>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='secondary'
          onClick={reset}
          data-mu-test='modal-saved-rows-btn-cancel'
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.Cancel'
          })}
        </Button>

        <Button
          kind='primary'
          onClick={handleConfirm}
          disabled={!name}
          data-mu-test='modal-saved-rows-btn-save'
        >
          {intl.formatMessage({
            id: 'Load.Common.Save'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
